"use client";

import Image from "next/image";
import { ButtonRadialFill } from "@/components/button-radial-fill";
import { usePageTransition } from "@/components/page-transition-provider";
import AboutSectionRight from "~/public/assets/about/about-section-right.png";
import Bg_Section from "~/public/assets/backgrounds/bg-section-bottom.png";
import LogoFlow from "~/public/assets/logo-flow.png";

export default function NotFound() {
	const { navigate } = usePageTransition();

	return (
		<div
			data-chromeless="true"
			className="relative min-h-screen overflow-hidden bg-[#050505] text-white"
		>
			<Image
				src={AboutSectionRight}
				alt=""
				priority
				aria-hidden="true"
				className="pointer-events-none absolute top-0 right-0 z-10 h-auto w-full max-w-190"
				width={2000}
				height={2000}
			/>

			<Image
				src={Bg_Section}
				alt="Background decorativo"
				className="absolute w-full h-full bottom-0 max-h-150 pointer-events-none scale-x-[-1] max-md:object-cover"
				priority={false}
				sizes="100vw"
			/>

			<section className="md:container-padding relative z-20 min-h-screen">
				<div className="container flex min-h-screen w-full items-center">
					<div className="">
						<Image
							src={LogoFlow}
							alt="Flow Lab Tech"
							priority
							className="h-auto w-full max-w-42"
						/>

						<div className="mt-20">
							<p className="text-xl text-primary-300 font-light">Error</p>

							<h1 className="mt-2 font-bricolage font-medium leading-[100%] text-[100px] xl:text-[140px]">
								404
							</h1>

							<h2 className="mt-2 description text-4xl">
								Ops! Página não encontrada.
							</h2>

							<p className="mt-2 description text-xl">
								Não encontramos a página desejada.
							</p>

							<ButtonRadialFill
								onClick={() => navigate("/")}
								className="mt-13 h-14.5 rounded-2xl border border-primary-300 bg-primary-300 px-6 text-base font-medium text-white"
								classNameFill="bg-gray-1100"
							>
								Ir para home
							</ButtonRadialFill>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
